// Мобильное меню бургер
let burger = document.querySelector(".burger");
let menu = document.querySelector(".header-menu__primary");
let loginUser = document.querySelector(".header-menu-user");
burger.addEventListener("click", () => {
  if (!menu.classList.contains("active")) {
    menu.classList.add("active");
    burger.classList.add("active-burger");
  } else {
    menu.classList.remove("active");
    burger.classList.remove("active-burger");
  }
});
function burgerMenu() {
  if (window.innerWidth > 1024) {
    menu.classList.remove("active");
    burger.classList.remove("active-burger");
    let reversResize = menu.querySelector(".header-menu-user");
    if (reversResize) {
      reversResize.remove();
      document.querySelector("header > .container").append(loginUser);
    }
  }
  if (window.innerWidth < 1024) {
    loginUser.remove();
    menu.append(loginUser);
  }
}

window.addEventListener("resize", () => {
  burgerMenu();
});
burgerMenu();

function linkContact() {
  let localUrl = location.href;
  if (!localUrl.split("/").includes("about-us")) {
    if (localUrl.split("/").includes("en")) {
      document
        .querySelector("li.contact__link > a")
        .setAttribute(
          "href",
          `${location.origin}` + "/en/" + "about-us/#contact"
        );
    }
    if (localUrl.split("/").includes("ru")) {
      document
        .querySelector("li.contact__link > a")
        .setAttribute(
          "href",
          `${location.origin}` + "/ru/" + "about-us/#contact"
        );
    }
    if (
      !localUrl.split("/").includes("ru") &&
      !localUrl.split("/").includes("en")
    ) {
      document
        .querySelector("li.contact__link > a")
        .setAttribute("href", `${location.origin}` + "/about-us/#contact");
    }
  } else {
    if (localUrl.split("/").includes("en")) {
      document
        .querySelector("li.contact__link > a")
        .setAttribute(
          "href",
          `${location.origin}` + "/en/" + "about-us/#contact"
        );
    }
    if (localUrl.split("/").includes("ru")) {
      document
        .querySelector("li.contact__link > a")
        .setAttribute(
          "href",
          `${location.origin}` + "/ru/" + "about-us/#contact"
        );
    }
    if (
      !localUrl.split("/").includes("ru") &&
      !localUrl.split("/").includes("en")
    ) {
      document
        .querySelector("li.contact__link > a")
        .setAttribute("href", `${location.origin}` + "/about-us/#contact");
    }
  }
}
linkContact();
